import {Component, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {} from '@types/googlemaps';
import { SpeakerService } from '../speaker.service';

@Component({
  selector : 'leaflet-map',
  templateUrl : './leaflet-map.component.html',
  styleUrls : [ './leaflet-map.component.css' ]
})
export class LeafletMapComponent implements OnInit {
  @Output() onLayerClick = new EventEmitter(); 
  
  options: any;

  overlays: any[];

  @ViewChild('mapContainer') mc;

  lat: number = 51.678418;
  lng: number = 7.809007;

  map: any;

  regions = [
    {
      'region' : 'Ireland',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Ireland.kml'
    },
    {
      'region' : 'London',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Ireland.kml'
    },
    {
      'region' : 'Midlands',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Midlands.kml'
    },
    {
      'region' : 'North',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/North.kml'
    },
    {
      'region' : 'Northern Ireland',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Northern%2520Ireland.kml'
    },
    {
      'region' : 'Scotland',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Scotland.kml'
    },
    {
      'region' : 'South East',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/South%2520East.kml'
    },
    {
      'region' : 'South West',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/South%2520West.kml'
    },
    {
      'region' : 'Wales',
      'url' :
          'https://gist.githubusercontent.com/encima/4fdfaa559af0e881abae8da17a6d1335/raw/1b9f89d12b78ecd25d37421ad7d43f65aaf74836/Wales.kml'
    }
  ];
  
  layers = [];
  
  constructor(private speaker: SpeakerService) {

  }

  ngOnInit() {
    this.options = {center : {lat : 54.559322, lng : -4.174804}, zoom : 5};
    console.log(this.options);
    this.speaker.tabChange.subscribe(tab => {
      if (this.map) {
        google.maps.event.trigger(this.map, 'resize');
        this.mc.triggerResize();
        this.map.setOptions(this.options);
        this.map.setCenter(new google.maps.LatLng(this.options.center.lat, this.options.center.lng));
      }
    });
  }

  onMapReady(map) {
    this.map = map;
    for (let i = 0; i < this.regions.length; i++) {
      let layer = new google.maps.KmlLayer(
          {url : this.regions[i]['url'], map : this.map});
      layer.addListener('click', event => { 
        console.log(event);
        this.onLayerClick.emit({src: "MAP", event: event});
      });
      this.layers.push(layer);
    }
  }

  mapClicked(event) {
    console.log(event);
    console.log(this.map.getZoom());
    this.map.setOptions(this.options);
  }
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/leaflet-map/leaflet-map.component.ts